import React, { createContext, useContext, useEffect, useState } from 'react';

const STORAGE_KEY = 'language';
const DEFAULT_LANG = 'en';

const LanguageContext = createContext();

export const LanguageProvider = ({ children }) => {
    const [language, setLanguageState] = useState(DEFAULT_LANG);
    const [isLoading, setIsLoading] = useState(true);

    useEffect(() => {
        try {
            const saved = localStorage.getItem(STORAGE_KEY);
            if (saved) {
                setLanguageState(saved);
            }
        } catch (error) {
            console.error('Failed to load language from localStorage', error);
        } finally {
            setIsLoading(false);
        }
    }, []);

    const setLanguage = (newLang) => {
        localStorage.setItem(STORAGE_KEY, newLang);
        setLanguageState(newLang);
    };

    const toggleLanguage = () => {
        const next = language === 'pt' ? 'en' : 'pt';
        setLanguage(next);
    };

    return (
        <LanguageContext.Provider value={{ language, setLanguage, toggleLanguage, isLoading }}>
            {children}
        </LanguageContext.Provider>
    );
};

export const useLanguage = () => useContext(LanguageContext);